import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "../LandingComponents/Typography"

import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"

import ProjectGrid from "../Projects/ProjectGrid"
import ViewAllButton from "../LandingComponents/ViewAllButton"

const useStyles = makeStyles((theme) => ({
  cardGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
}))

const ProjectsGrid = ({ projectList, showAll, allProjPics }) => {
  const classes = useStyles()

  return (
    <Container className={classes.cardGrid} maxWidth="lg">
      {showAll && (
        <>
          <Typography gutterBottom component="h2" variant="h5">
            Current Projects
          </Typography>

          <Typography>
            Projects with on-going research and engineering work
          </Typography>
        </>
      )}

      <Grid container spacing={4}>
        {projectList.map(
          (proj) =>
            proj.status === "on-going" && (
              <ProjectGrid
                allProjPics={allProjPics}
                imgHeight={100}
                mini={true}
                proj={proj}
              />
            )
        )}
      </Grid>

      {!showAll && <ViewAllButton destination="/projects" />}
    </Container>
  )
}

ProjectsGrid.propTypes = {
  projectList: PropTypes.array.isRequired,
  showAll: PropTypes.bool.isRequired,
  allProjPics: PropTypes.array.isRequired,
}

export default ProjectsGrid
